// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyCfoUHA3qVj70RK8zrl3e-4kLEl1xlXi4g",
  authDomain: "selenne-strategies.firebaseapp.com",
  databaseURL: "https://selenne-strategies-default-rtdb.firebaseio.com",
  projectId: "selenne-strategies",
  storageBucket: "selenne-strategies.firebasestorage.app",
  messagingSenderId: "256452657433",
  appId: "1:256452657433:web:b587b3113db206699dc588"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);

